import {
  Avatar,
  Card,
  CardContent,
  Grid,
  Typography,
} from '@mui/material';
import { useSelector } from 'react-redux';
import { TrendingUp } from '@mui/icons-material';
import { green } from '@mui/material/colors';
import { formatNumber } from '../../utils';

function Budget(props) {
  // const dispatch = useDispatch();
  const userState = useSelector((state) => state.userReducer);
  const { counts, loadingCount } = userState;

  return (
    <Card
      className="customCard"
      sx={{ height: '100%' }}
      {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={3}
          sx={{ justifyContent: 'space-between' }}
        >
          <Grid item>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              TOTAL SALES
            </Typography>
            <Typography
              color="textPrimary"
              variant="h3"
            >
              {loadingCount ? '...' : `KES ${formatNumber(counts.totalSales)}`}

            </Typography>
          </Grid>
          <Grid item>
            <Avatar
              sx={{
                backgroundColor: green[600],
                height: 56,
                width: 56,
              }}
            >
              <TrendingUp />
            </Avatar>
          </Grid>
        </Grid>
        {/* <Box
        sx={{
          pt: 2,
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <ArrowDownwardIcon sx={{ color: red[900] }} />
        <Typography
          sx={{
            color: red[900],
            mr: 1,
          }}
          variant="body2"
        >
          12%
        </Typography>
        <Typography
          color="textSecondary"
          variant="caption"
        >
          Since last month
        </Typography>
      </Box> */}
      </CardContent>
    </Card>
  );
}

export default Budget;
